import http from '@/utils/http'
import { DEFAULT_RESOURCE_TYPE } from '@/utils/constants'

// get some type resoruce, include `source` and `sinks` conf keys
export const getConfigKeyResources = (nodeID, params = {}) => {
  const url = `/kuiper/${nodeID}/metadata/resources`
  return http.get(url, { params })
}

/**
 * get metadata or get the name metadata by category
 * @param { String } category sources | sinks | functions | ops | connections | connections
 * @param { Object } data { nodeID, name }
 * @param { Object } params ...
 */
export const getMetadataByCategory = (category = DEFAULT_RESOURCE_TYPE, data = {}, params = {}) => {
  const { nodeID, name } = data
  let getUrl = `/kuiper/${nodeID}/metadata/${category}`
  if (name) {
    getUrl = `${getUrl}/${name}`
  }
  return http.get(getUrl, { params })
}

export const getMetadataYamlByCategory = (category = DEFAULT_RESOURCE_TYPE, data = {}, params = {}) => {
  const { nodeID, name } = data
  let getUrl = `/kuiper/${nodeID}/metadata/${category}/yaml`

  if (name) {
    getUrl = `${getUrl}/${name}`
  }
  return http.get(getUrl, { params })
}

// test connection
export const testConnectionByCategory = (category = DEFAULT_RESOURCE_TYPE, data, body = {}) => {
  const { nodeID, type } = data
  return http.post(`/kuiper/${nodeID}/metadata/${category}/connection/${type}`, body)
}

export const loadSourceDetail = (nodeID, source) => {
  return http.get(`/kuiper/${nodeID}/metadata/sources/yaml/${source}`)
}

export const getSourceConfKeys = (nodeID, source) => http.get(`/kuiper/${nodeID}/metadata/sources/${source}/confKeys`)

export const addSourceConfKey = (nodeID, source, name, body = {}, configuration) => {
  let postUrl = `/kuiper/${nodeID}/metadata/sources/${source}/confKeys`
  if (name) {
    postUrl = `${postUrl}/${name}`
  }
  if (configuration) {
    postUrl = `${postUrl}/${configuration}`
  }
  return http.put(postUrl, body)
}

export const addSinksConfKey = (nodeID, type, name, body = {}, configuration) => {
  let postUrl = `/kuiper/${nodeID}/metadata/sinks/${type}/confKeys`
  if (name) {
    postUrl = `${postUrl}/${name}`
  }
  if (configuration) {
    postUrl = `${postUrl}/${configuration}`
  }
  return http.put(postUrl, body)
}

export const deleteSourceConfKey = (nodeID, source, name) => {
  return http.delete(`/kuiper/${nodeID}/metadata/sources/${source}/confKeys/${name}`)
}

export const deleteSinkConfKey = (nodeID, sink, name) => {
  return http.delete(`/kuiper/${nodeID}/metadata/sinks/${sink}/confKeys/${name}`)
}

export default {}
